<div
  id="hero"
  [style.background-image]="
    data && media && media.MediaType != 2 && media.Url
      ? 'url(' +
        (media.Url
          | apiImage
            : (!isMobile ? 1500 : 500)
            : media
            : 'fit'
            : 0
            : false
            : 80) +
        ')'
      : ''
  "
>
  @if (data && media && media.MediaType == 2) {
    <video autoplay muted loop id="top-video">
      <source
        [src]="apiDomain + 'upload/frontpage/' + media.Url"
        type="video/mp4"
      />
    </video>
  }
  <app-search-box
    [currentSearchBoxData]="currentSearchBoxData"
  ></app-search-box>
</div>
@if (data.TopText) {
  <div class="top-text">
    <div class="content">
      @if (data.TopText) {
        <app-inner-html [html]="data.TopText"></app-inner-html>
      }
    </div>
  </div>
}
@if (data.Sections) {
  <div id="destinations">
    @for (section of data.Sections; track section; let i = $index) {
      <div class="section-row">
        <div
          class="{{
            !section.ShowSectionsAsRow
              ? 'destination-row destinations-' + section.Contents?.length
              : 'location-row-wrapper'
          }}"
          [ngClass]="{
            'destination-row destinations-{{section.Contents.length}}':
              !section.ShowSectionsAsRow,
          }"
        >
          @if (section.ShowSectionsAsRow) {
            @if (section.Description) {
              <app-inner-html class="text" [html]="section.Description">
              </app-inner-html>
            }
            <div
              class="location-row-list"
              [ngStyle]="{
                'grid-template-columns':
                  'repeat(' +
                  getLocationColumnCount(section.Contents?.length ?? 0) +
                  ', minmax(0, 1fr))',
              }"
            >
              @for (content of section.Contents; track content) {
                <a
                  [routerLink]="content.Url"
                  attr.aria-label="{{ content.Name }}"
                >
                  <div class="image">
                    @if (content.Media && content.Media.Url) {
                      <img
                        [src]="
                          content.Media.Url
                            | apiImage: 310 : content.Media : 'fill' : 310
                        "
                        [width]="310"
                        [height]="310"
                        loading="lazy"
                        [alt]="content.Media.Caption ?? content.Name"
                      />
                    }
                  </div>
                  <p>{{ content.Name }}</p>
                </a>
              }
            </div>
          } @else {
            @for (content of section.Contents; track content) {
              <div class="box">
                @if (section.Contents) {
                  <div class="destination-content">
                    <a
                      [routerLink]="content.Url"
                      attr.aria-label="{{ content.Name }}"
                    >
                      <div class="image-wrapper">
                        @if (content.Media && content.Media.Url) {
                          <img
                            [src]="
                              content.Media.Url
                                | apiImage: 550 : content.Media : 'fill'
                            "
                            [height]="content.Media | imageSize: 550"
                            [width]="550"
                            [alt]="
                              content.Media.Caption ?? section.Contents[0].Name
                            "
                            loading="lazy"
                          />
                        }
                      </div>
                      <p>{{ content.Name }}</p>
                    </a>
                  </div>
                }
              </div>
            }
            <div
              class="section-header"
              [ngClass]="{
                center: section.Contents && section.Contents.length > 0,
              }"
            >
              @if (section.Description) {
                <app-inner-html class="text" [html]="section.Description">
                </app-inner-html>
              }
            </div>
            <div class="center-line"></div>
          }
        </div>
        @if (section.Hotels && section.Hotels.length > 0) {
          <div class="destination-row hotel-list-wrapper">
            <app-property-list
              [properties]="section.Hotels"
              [showShortDescriptionText]="true"
              [locationId]="0"
              [wider]="false"
              [settings]="settings"
            ></app-property-list>
          </div>
        }
        <div id="section-rendered"></div>
      </div>
    }
  </div>
}
@if (data.Faqs && data.Faqs.length > 0) {
  <div id="faq">
    <div class="container">
      <h2>{{ 49 | translate }}</h2>
      <app-faq-list [faqs]="data.Faqs"></app-faq-list>
    </div>
  </div>
}
